export default __webpack_public_path__ + "static/media/highlight-image-modal@2x.85cc6f99.png";